import { type SvgIconProps } from '@mui/material';
import React from 'react';

function FullCalendarIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 -1 41 41"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_6068_86238"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6068_86238)">
        <path
          d="M36 32.5745V7.08962C36 6.90302 35.9305 6.72312 35.8049 6.58506L33.1998 3.72005C33.0577 3.56373 32.8562 3.47461 32.6449 3.47461H3.33347C3.12117 3.47461 2.91883 3.56458 2.77662 3.72219L0.193154 6.58555C0.0688203 6.72335 0 6.90236 0 7.08796V32.5761C0 32.7658 0.0718791 32.9485 0.20116 33.0872L2.77755 35.8536C2.91943 36.0059 3.11823 36.0925 3.32639 36.0925H32.6519C32.8591 36.0925 33.0571 36.0068 33.1988 35.8558L35.7968 33.0877C35.9273 32.9486 36 32.7651 36 32.5745Z"
          fill="#FF5200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.8747 0C7.46049 0 7.1247 0.335786 7.1247 0.75V7.12518C7.1247 7.53938 7.46049 7.87515 7.8747 7.87515H8.2497C8.66393 7.87515 8.9997 7.53938 8.9997 7.12518V0.75C8.9997 0.335786 8.66393 0 8.2497 0H7.8747ZM17.813 0C17.3987 0 17.063 0.335786 17.063 0.75V7.12518C17.063 7.53938 17.3987 7.87515 17.813 7.87515H18.188C18.6022 7.87515 18.938 7.53938 18.938 7.12518V0.75C18.938 0.335786 18.6022 0 18.188 0H17.813ZM27.0012 0.75C27.0012 0.335786 27.337 0 27.7512 0H28.1262C28.5403 0 28.8762 0.335786 28.8762 0.75V7.12518C28.8762 7.53938 28.5403 7.87515 28.1262 7.87515H27.7512C27.337 7.87515 27.0012 7.53938 27.0012 7.12518V0.75ZM9.66292 13.7388H6.32812V17.0736H9.66292V13.7388ZM13.1384 13.7388H16.4732V17.0736H13.1384V13.7388ZM13.1384 20.4084H16.4732V23.7432H13.1384V20.4084ZM16.4732 27.0781H13.1384V30.4129H16.4732V27.0781ZM26.4777 13.7388H29.8125V17.0736H26.4777V13.7388ZM29.8125 20.4084H26.4777V23.7432H29.8125V20.4084ZM26.4777 27.0781H29.8125V30.4129H26.4777V27.0781ZM6.46875 20.4084H9.80355V23.7432H6.46875V20.4084ZM9.80355 27.0781H6.46875V30.4129H9.80355V27.0781ZM19.808 13.7388H23.1428V17.0736H19.808V13.7388ZM23.1428 20.4084H19.808V23.7432H23.1428V20.4084ZM19.808 27.0781H23.1428V30.4129H19.808V27.0781Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export default FullCalendarIcon;
